/*
---
description: FED Process
authors:
- David Chan CK
- Anton Burov
license:
- MIT-style license
requires:
- core/1.4.5: '*'
...
*/

var Photogallery = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_photogallery',
		first_image: null,
		width_by_thumbs: 5, //has to be odd or 0 if thumbs are hidden
		animate: false, //use for slideshow
		scroll_speed: 200,
		in_popup: false,
		no_fullscreen_opt: false, //no fullscreen option if true
		no_enlarge_opt: true, //no fullscreen option if true
		thumbs: null, //used for full screen gallery
		show_controllers: false, //always display controllers
		single_img_cls: '',
		fs_class: 'fs',//class for fullscreen,
		en_class: 'en',//class for enlarge screen
		thumbnail_mode: false,//gallery needs class _thumbnails,
		missing_img: null,
		videos: false,
		dont_adjust_img_css: null,
		onFsClose: function(){}
	},

	initialize: function(element, options){
		this.setOptions(options);
		this._element = element;
		this.cls = this.options.cls;

		if(this._element){
			this.build();
			this.adaFix();
		}
	},

	adaFix: function() {
		this._element.setAttribute('aria-label', 'carousel');
		this._element.setAttribute('role', 'region');
	},

	build: function(){
		var fcls = '.' + this.cls;

		this.is_touched = false;
		this.normal_mode = true;
		this.fullscreen_mode = false;
		this.enlarge_mode = false;
		this._main = this._element.getElement(fcls + '_main');
		if (this.options.videos) {
			this._main.addClass('videos');
		}
		this._bottom = this._element.getElement(fcls + '_bottom');
		this._strip = this._element.getElement(fcls + '_strip');
		this._thumbs = this.options.thumbs || this._strip.getElements('.thumb');

		if(!this._thumbs || this._thumbs.length == 0){
			this._element.dispose();
			return;
		}

		var error_img_url = (this.options.missing_img)? this.options.missing_img : Res_i + '/l/missing_big.png';

		this._thumbs.each(function(_el){
			if (_el.getAttribute('type') === 'video') {
				_el._full_img = new Element('iframe', {
					class: 'iframe-fullscreen',
					'src': Res_i + '/l/dummy.png',
					'allowfullscreen': 1,
					'onerror': 'this.src=\'' + error_img_url + '\''
				});
			} else {
				_el._full_img = new Element('img', {
					'src': Res_i + '/l/dummy.png',
					'onerror': 'this.src=\'' + error_img_url + '\''
				});
			}

			_el._full_cont = new Element('div', {
				'class': 'img_transition'
			}).adopt(_el._full_img);

			_el._full_cont.inject(this._main);

			var url = _el.getElement('img') ? _el.getElement('img').getAttribute('data-url') : null;

			if(url){
				_el._full_cont.setStyle('cursor', 'pointer');

				_el._full_cont.addEvent('click', function(){
					window.location = url;
				});
			}
		}.bind(this));

		if(this._thumbs && this._thumbs.length < this.options.width_by_thumbs){
			var dummies_amount = this.dummies_amount =	this.options.width_by_thumbs - this._thumbs.length;

			for(var i=0; i<dummies_amount; i++){
				new Element('div', {'class': 'thumb _dummy', 'html': '&nbsp;'}).inject(this._strip);
			}
		}

		var _controllers = this._main.getElement(fcls + '_controllers');

		if(_controllers && this.options.show_controllers){
			_controllers.show();
		}

		this._arrow_previous = this._main.getElement(fcls + '_arrow_previous');
		this._arrow_next = this._main.getElement(fcls + '_arrow_next');
		this._fullscreen = this._main.getElement(fcls + '_fullscreen');
		this._enlarge = this._main.getElement(fcls + '_enlarge');
		this._thumbs_left = this._element.getElement(fcls + '_bottom .move_left');
		this._thumbs_right = this._element.getElement(fcls + '_bottom .move_right');
		this._image_counter = this._element.getElement(fcls + '_image_counter');

		this._progress = new Element('div', {
			'class': 'ajax_loader',
			'html': '&nbsp;'
		});

		this._progress.inject(this._main, 'top');

		this.current_cont = 0;
		this.to_center = true;

		this.set_appearance();
		this.set_functionality();

		if(this.options.thumbnail_mode)
			this.set_thumb_mode();

		if(this._element.hasClass('_slide')){
			this.move_caption();
		}
	},
	set_thumb_mode: function(){
		var self = this;
		var fcls = '.' + this.cls;
		var _enlarges = this._element.getElements(fcls + '_thumb .thumb .w_photogallery_enlarge');

		if(_enlarges.length > 0){
			_enlarges.each(function(el){
				el.addEvent('click', function(){
					self.select_thumb(parseInt(el.getParent().getAttribute('data-key')));
					self.go_fullscreen_mode(self.options.en_class);
				});
			});
		}
	},
	set_appearance: function(){
		var opts = this.options;

		if(opts.first_image && opts.first_image != ''){
			this._thumbs[0]._full_img.setProperty('src', opts.first_image);
			this._thumbs[0]._full_cont.fade('show');
		}

		if(opts.width_by_thumbs % 2 == 1){
			this.margin = this._thumbs[0].getStyle('margin-left').toInt() + this._thumbs[0].getStyle('margin-right').toInt();
			this.thumb_width = this._thumbs[0].getSize().x;
			this.strip_width = (this.thumb_width + this.margin) * (this._thumbs.length + (this.dummies_amount || 0)) - this._thumbs[0].getStyle('margin-left').toInt();

			this.main_width = (this.thumb_width + this.margin) * opts.width_by_thumbs - this._thumbs[0].getStyle('margin-left').toInt();

			this._thumbs[0].setStyle('margin-left', 0);

			this._strip.setStyles({
				'width': this.strip_width,
				'left': 0
			});

		}else{
			this.main_width = this._main.getSize().x;

			var _bottom = this._element.getElement('.' + opts.cls + '_bottom');

			if(_bottom){
				_bottom.hide();
				this._element.addClass('_no_thumbnails');
			}
		}

		if((this.main_width == 0 || this.main_width == null) && opts.width){
			this.main_width = opts.width;
		}

		// NCR-6855
		// if(this.main_width > 0 && opts.in_popup && !opts.fullscreen){
			// this._element.setStyle('width', this.main_width);
		// }

		if(opts.no_fullscreen_opt){
			this._fullscreen.hide();
		}

		if(opts.no_enlarge_opt && this._enlarge){
			this._enlarge.hide();
		}

		this.main_height = this._main.getSize().y;

		if(opts.fullscreen){
			this.img_cont_width = '100%';
			this.img_cont_height = '100%';
			this.main_height = '100%';
		}else{
			var _cont = this._thumbs[0]._full_cont;

			this.img_cont_width = this.main_width - _cont.getParent().getStyle('padding-left').toInt()*2 - _cont.getParent().getStyle('border-width').toInt()*2;
			this.img_cont_height = this.main_height - _cont.getParent().getStyle('padding-top').toInt()*2 - _cont.getParent().getStyle('border-width').toInt()*2;
		}

		var zi_1 = this._thumbs[0]._full_cont.getStyle('z-index').toInt();

		this._progress.setStyle('z-index', zi_1 + 1);
		this._progress.fade('hide');

		this._thumbs.each(function(_el, i){
			_el.addEvent('click', function(){
				this.to_center = false;
				this.select_thumb(i);

			}.bind(this));
		}.bind(this));

		this.thumbs_arrows_set_class();
	},

	set_functionality: function(){
		var self = this;

		this._main.addEvents({
			'mouseenter' : function() {
				self._main.addClass('_active');
			},

			'mouseover' : function() {
				self._main.addClass('_active');
			},

			'mouseout' : function() {
				self._main.removeClass('_active');
			},

			'click' : function() {
				var url = self._element.get('data-url') || self._thumbs[self.current_img].get("data-url");

				if(!url) return;

				window.location = url;
			}
		});

		if(this._fullscreen && !this.options.no_fullscreen_opt){
			this._fullscreen.addEvents({
				'click': function(e){
					if(e && e.stop) e.stop();
					if(self.fullscreen_mode){
						this.go_normal_mode();
					}else{
						this.go_fullscreen_mode(this.options.fs_class);
					}
				}.bind(this),

				'touchstart': function(e){
					if(e && e.stop) e.stop();

					self._fullscreen.fireEvent('click');
					return false;
				}
			});
		}

		if(this._enlarge && !this.options.no_enlarge_opt){
			this._enlarge.addEvents({
				'click': function(e){
					if(e && e.stop) e.stop();

					if(self.fullscreen_mode){
						this.go_normal_mode();
					}else{
						this.go_fullscreen_mode(this.options.en_class);
					}
				}.bind(this),

				'touchstart': function(e){
					if(e && e.stop) e.stop();

					self._enlarge.fireEvent('click');
					return false;
				}
			});
		}

		if(this._thumbs.length == 1){
			this.hide_controllers();
			this._element.addClass(this.options.single_img_cls);
			return;
		}

		this._thumbs.each(function(_el){
			var _first_img = _el._full_img

			_first_img.addEvent('load',function(){
				self.fireEvent('firstImageLoad');
			});
		});

		this.select_thumb(0);

		if(this._thumbs.length > 1){
			this._arrow_previous.addEvents({
				'click': function(e){
					if(e && e.stop) e.stop();

					this.to_center = true;
					this.select_thumb(this.previous_img);

				}.bind(this),

				'touchstart': function(e){
					if(e && e.stop) e.stop();

					self._arrow_previous.fireEvent('click');
					return false;
				}
			});

			this._arrow_next.addEvents({
				'click': function(e){
					if(e && e.stop) e.stop();

					this.to_center = true;
					this.select_thumb(this.next_img);
				}.bind(this),

				'touchstart': function(e){
					if(e && e.stop) e.stop();

					self._arrow_next.fireEvent('click');
					return false;
				}
			});

			if(this._thumbs.length > this.options.width_by_thumbs){
				this._thumbs_left.addEvent('click', function(e){
					if(e && e.stop) e.stop();

					this.to_center = false;
					this.move_thumbs('left');
				}.bind(this));

				this._thumbs_right.addEvent('click', function(e){
					if(e && e.stop) e.stop();

					this.to_center = false;
					this.move_thumbs('right');
				}.bind(this));

				this.move_strip = new Fx.Morph(this._strip, {
					link: 'ignore',
					duration: this.options.scroll_speed
				});
			}else{
				this._thumbs_left.hide();
				this._thumbs_right.hide();
			}
		}
	},

	thumb_is_preloaded: function(_thumb) {
		var is_preloaded = _thumb.getAttribute('data-preloaded');
		return (is_preloaded == "1");
	},

	select_thumb: function(indx){
		if (typeof(indx) === 'string') {
			indx = indx.toInt();
		}

		var th = this._thumbs[indx];

		if (indx != 0 && !this.is_touched) {
			this.is_touched = true;
		}

		if(this._previous_thumb && this._previous_thumb !== th){
			this._previous_thumb.removeClass('current');
		}

		if(this._previous_thumb !== this._thumbs[indx]){
			th.addClass('current');

			this.load(th);
			this.setImageCounter(indx);

			this._previous_thumb = th;
		}

		if(this.to_center == true && this.options.width_by_thumbs%2 == 1){
			this.move_thumbs_auto(indx);
		}

		this.set_next_and_previous_img(indx);
	},

	preload_all: function(ignore_idx) {
		ignore_idx = ignore_idx || null;

		this._thumbs.each(function(itm, i) {
			if (i == ignore_idx){return;}
			itm.setAttribute('data-preloaded', 1);
			new Asset.image(itm.getAttribute('data-full'));
		});
	},

	load: function(th){
		var self = this;
		var path = this.fullscreen_mode ? th.getAttribute('data-fullscreen') : th.getAttribute('data-full');

		this.show_image(th, path);
	},

	show_image: function(th, path) {

		var img = th._full_img;
		img.set('src', path);

		var error_img_url = (this.options.missing_img) ? this.options.missing_img : Res_i + '/l/missing_big.png';
		img.set('onerror', 'this.src = "' + error_img_url + '"');

		if (th.getAttribute('type') !== 'video') {
			if (!this.options.dont_adjust_img_css) {
				this.adjust_img_css(img);
			}
		}

		this.img_transition(th);

		this._current_cont = th._full_cont;

		this.update_caption(th);

		this.fireEvent('showImage');
	},

	adjust_img_css: function(img){
		if(!img) return;

		var size = {x: img.width, y: img.height};
		var img_cont_width = this._main.getSize().x;
		var img_cont_height = this._main.getSize().y;

		// get ratio to see if the image is wider or higher
		// if it is wider, set width to 100%
		// if it is higher, set heigh to 100%
		var xRatio = size.x / img_cont_width;
		var yRatio = size.y / img_cont_height;
		if ( xRatio >= yRatio ) {
			img.setStyles ({
				'width': '100%',
				'height': 'auto'
			});
		} else {
			img.setStyles ({
				'width': 'auto',
				'height': '100%'
			});
		}

	},

	img_transition: function(th){
		if(this._current_cont){
			this._current_cont.setStyles({
				opacity: 0,
				visibility: 'hidden'
			});
		}

		th._full_cont.setStyles({
			opacity: 1,
			visibility: 'visible'
		});

		this._progress.setStyles({
			opacity: 0,
			visibility: 'hidden'
		});
	},

	go_fullscreen_mode: function(fullscreen_type){
		this.save_position();
		this.normal_mode = false;
		if(fullscreen_type == this.options.fs_class)
			this.show_fs_mode();


		if(fullscreen_type == this.options.en_class)
			this.show_en_mode();

	},

	show_fs_mode: function(){

		this.enlarge_mode = false;
		this.fullscreen_mode = true;

		var self = this;
		this._fs_gallery = new Element('div', {'class': 'w_fs_gallery', 'aria-label': 'modal dialog', 'role': 'region'}).inject(document.body);

		var _gallery_cont = new Element('div', {'class': 'w_fs_gallery_cont'}).inject(this._fs_gallery);
		var _close = new Element('button', {'class': 'w_fs_close no-border', 'html': 'Close'}).inject(_gallery_cont);

		_close.addEvent('click', function(){
			self.go_normal_mode();
		});

		this._element.inject(_gallery_cont);
		var th = this._thumbs[this.current_img];
		this.load(th);
		this.removeTabbingRestriction = Core.disableTabbingOutside(this._fs_gallery);
		_close.focus();

	},

	show_en_mode: function(){
		this.enlarge_mode = true;
		this.fullscreen_mode = false;

		var self = this;

		this._veil = new Element('div.w_popup_veil').inject(document.body);

		this._en_gallery = new Element('div.w_en_gallery').inject(document.body);
		var _gallery_cont = new Element('div.w_en_gallery_cont').inject(this._en_gallery);
		var _close = new Element('button', {'class': 'w_en_close no-style', 'html': '&nbsp;'}).inject(_gallery_cont);

		_close.addEvent('click', function(){
			self.go_normal_mode();
		});

		this._element.inject(_gallery_cont);
		var th = this._thumbs[this.current_img];
		this.load(th);
		this.center_element(this._en_gallery);

		this._enlarge_mode_title = new Element('h3', {'html': th.getElement('img').get('title')}).inject(_gallery_cont, 'top');

		this.removeTabbingRestriction = Core.disableTabbingOutside(this._en_gallery);
		_close.focus();
	},

	center_element: function(_element){
		_element.setStyles({
			position: 'absolute'
		});

		var win_scroll = window.getScroll(),
				win_size = window.getSize(),
				el_size = _element.getSize();

		var pos_y = win_scroll.y + Math.floor(Math.max(0, (win_size.y - el_size.y)/2));

		if(Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android'){
			win_size.x = Math.max(win_size.x, document.getElement('body').offsetWidth);
		}

		var pos_x = win_scroll.x + Math.floor(Math.max(0, (win_size.x - el_size.x)/2));

		_element.setStyles({
				top: pos_y,
				left: pos_x
		});
	},

	save_position: function(){
		if(this._element.getPrevious()){
			this._prev_el = this._element.getPrevious();
		}else if(this._element.getNext()){
			this._next_el = this._element.getNext();
		}else{
			this._parent = this._element.getParent();
		}
	},
	restore_position: function(){
		if(this._prev_el){
			this._element.inject(this._prev_el, 'after');
		}else if(this._next_el){
			this._element.inject(this._next_el, 'before');
		}else{
			this._element.inject(this._parent);
		}

	},

	go_normal_mode: function(){

		this.restore_position();
		var trigger;
		if(this._fs_gallery){
			this._fs_gallery.destroy();
			this.fullscreen_mode = false;
			trigger = this._fullscreen;
		}
		if(this._veil)
			this._veil.destroy();

		if(this._en_gallery){
			this._en_gallery.destroy();
			this.enlarge_mode = false;
			trigger = this._enlarge;
		}
		this.normal_mode = true;
		var th = this._thumbs[this.current_img];
		this.load(th);
		this.fireEvent('fsClose');

		trigger && trigger.focus();
		this.removeTabbingRestriction();
	},

	animate: function(){
		this.select_thumb(this.next_img);
	},

	set_next_and_previous_img: function(indx){
		if (typeof(indx) === 'string') {
			indx = indx.toInt();
		}

		this.current_img = indx;
		if(indx == 0){
			this.next_img = 1;
			this.previous_img = this._thumbs.length - 1;
		}else if(indx == this._thumbs.length - 1){
			this.next_img = 0;
			this.previous_img = indx - 1;
		}else{
			this.next_img = indx + 1;
			this.previous_img = indx - 1;
		}
	},

	move_thumbs: function(side){
		if(side=='left' && !this._thumbs_left.hasClass('inactive')){
			var move = this._strip.getStyle('left').toInt() + (this.thumb_width + this.margin);
			if(move > 0){
				move = 0;
			}
		}else if(side=='right' && !this._thumbs_right.hasClass('inactive')){
			var move = this._strip.getStyle('left').toInt() - (this.thumb_width + this.margin);
		}

		if(!this.move_strip) return;

		if(move || move == 0){
			this.move_strip.start({
				'left': move
			}).chain(function(){
				this.thumbs_arrows_set_class();
			}.bind(this));
		}
	},

	move_thumbs_auto: function(indx){
		var half = Math.floor(this.options.width_by_thumbs/2);
		var thumb_to_center;

		if(this.options.width_by_thumbs < this._thumbs.length){
			if(indx <= half){
				thumb_to_center = 0;
			}else if(indx >= this._thumbs.length - half - 1){
				thumb_to_center = this.main_width - this.strip_width;
			}else{
				thumb_to_center = -(this._strip.getSize().x - (this._thumbs.length - indx + half) * (this.thumb_width + this.margin) + this.margin);
			}

			if ((this._strip.getSize().x - (this.thumb_width*(indx))) < this._bottom.getSize().x){
				thumb_to_center = -(this._strip.getSize().x - this._bottom.getSize().x);
			}

			if(!this.move_strip || (this.strip_width <= this._bottom.getSize().x)) {
				return;
			}

			this.move_strip.start({'left': thumb_to_center}).chain(function(){
				this.thumbs_arrows_set_class();
			}.bind(this));
		}
	},

	thumbs_arrows_set_class: function(){
		if(!this._strip) return;

		if(this._strip.getStyle('left').toInt() >= 0){
			this._thumbs_left.addClass('inactive');
		}else{
			this._thumbs_left.removeClass('inactive');
		}

		if( (this.strip_width <= this.main_width)||
			(this._bottom.getSize().x > (this._strip.getSize().x + this._strip.getStyle('left').toInt()))
		){
			this._thumbs_right.addClass('inactive');
		}else{
			this._thumbs_right.removeClass('inactive');
		}
	},

	hide_controllers: function(){
		this.select_thumb(0);

		if(this._strip){
			this._strip.getParent().hide();
			this._element.addClass('_no_thumbnails');
		}

		if(this._fullscreen){
			var _divider = this._arrow_previous.getParent().getElement('.divider');

			if(_divider){
				_divider.dispose();
			}

			this._arrow_previous.hide();
			this._arrow_next.hide();
		}else if(this._arrow_previous){
			this._arrow_previous.getParent().hide();
		}
	},

	update_caption: function(_th){
		var _caption = this._element.getElement('.' + this.options.cls + '_caption span');

		if(!_caption) return;

		_caption.set('html', _th.getElement('img').get('title'));

		if(this._enlarge_mode_title)
			this._enlarge_mode_title.set('html',_caption.get('html'));
	},

	move_caption: function(){
		var _caption = this._element.getElement('.' + this.options.cls + '_caption');

		if(!_caption) return;

		_caption.inject(this._element);
	},

	setImageCounter: function(indx) {
		if (this._image_counter) {
			var current_idx = indx + 1;
			this._image_counter.set('text', current_idx + ' / ' + this._thumbs.length + ' Photos');
		}
	}
});
